// The safety net behind Forget: what the last one removed, offered back.
//
// The typed confirmation stops the accidental click; this covers the deliberate one that
// turns out to be wrong. Forgetting is otherwise unrecoverable from the UI — the pairs are
// gone from disk, and re-creating one means finding both rows in the grids again — so the
// window between "that was a mistake" and "it is gone" was a page reload wide.
//
// It is short-lived ON PURPOSE, and says so: the restore puts back a snapshot taken at the
// moment of the Forget, so it is only correct until the next change moves what it would be
// restored into. Both tabs render it, so the two identical-looking Forget buttons behave
// identically.
export default function ForgetUndoBanner({ count, disabled, onUndo }: {
  count: number;
  disabled?: boolean;
  onUndo: () => void;
}) {
  if (count <= 0) return null;
  return (
    <div className="undo-banner" role="status">
      <span className="badge badge-warn">{count} forgotten</span>
      <span className="muted undo-banner-text">
        {count === 1 ? "That saved match was" : `Those ${count} saved matches were`} deleted
        from this insurer's store. You can put {count === 1 ? "it" : "them"} back here — the
        offer lasts until your next change on this tab, and does not survive a reload.
      </span>
      <button className="btn btn-primary" disabled={disabled} onClick={onUndo}>
        {count === 1 ? "Undo — restore it" : `Undo — restore all ${count}`}
      </button>
    </div>
  );
}
